import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './style.scss';


const PaymentsRibbon = ({ size }) => (
  <div className={classNames(styles.subscriptionRibbon, styles[`subscriptionRibbon${size}`])}>
    <span className={classNames(styles.subscriptionRibbonText, styles[`subscriptionRibbonText${size}`])}>Новинка</span>
  </div>
);

PaymentsRibbon.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'big']),
};

PaymentsRibbon.defaultProps = {
  size: 'medium',
};

export default PaymentsRibbon;

